module.exports = __webpack_public_path__ + "static/img/bg_reward_item_purple.39c91135.png";